import request from '@/utils/request'

// 審批型別列表
export function oaExamineCategoryList(data) {
  return request({
    url: 'oa/examine/categoryList',
    method: 'post',
    data: data
  })
}

// 審批新建
export function oaExamineSave(data) {
  return request({
    url: 'oa/examine/save',
    method: 'post',
    data: data
  })
}

// 審批編輯
export function oaExamineUpdate(data) {
  return request({
    url: 'oa/examine/update',
    method: 'post',
    data: data
  })
}

// 審批列表
export function oaExamineIndex(data) {
  return request({
    url: 'oa/examine/index',
    method: 'post',
    data: data
  })
}

// 審批刪除
export function oaExamineDelete(data) {
  return request({
    url: 'oa/examine/delete',
    method: 'post',
    data: data
  })
}

// 審批詳情
export function oaExamineRead(data) {
  return request({
    url: 'oa/examine/read',
    method: 'post',
    data: data
  })
}

// OA審批審覈
export function oaExamineCheck(data) {
  return request({
    url: 'oa/examine/check',
    method: 'post',
    data: data
  })
}

// OA審批撤回審批
export function oaExamineRevokeCheck(data) {
  return request({
    url: 'oa/examine/revokeCheck',
    method: 'post',
    data: data
  })
}
